





















































































































































































































































































































import Vue from 'vue'
import Channel from '@/types/Channel.interface'
import IListTile from '@/types/components/IListTile.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListTileColumn from '@/types/components/IListTileColumn.interface'
import InboxToolbar from '@/components/InboxToolbar.vue'
import { mapGetters } from 'vuex'
import Message from '@/types/Message.interface'
import messageSendMixin from '@/mixins/message-mixin'
import Person from '@/types/Person.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import PersonProfile from '@/components/PersonProfile.vue'
import SmsMessagesPanel from '@/components/SmsMessagesPanel.vue'
import MessageTextForm from '@/components/MessageTextForm.vue'
import MessageToForm from '@/components/MessageToForm.vue'
import TypingIndicator from '@/components/TypingIndicator.vue'
import TriPanel from '@/components/TriPanel.vue'
import User from '@/types/User.interface'
import UserLogo from '@/components/UserLogo.vue'
import IListIcon, {
    IListBadge,
    IListIconType
} from '@/types/components/IListIcon.interface'
import Invitation from '@/types/Invitation.interface'
import Button from '@/types/components/Button.interface'
import inboxMixin from '@/mixins/inbox-mixin'
import TabPanel from '@/components/TabPanel.vue'
import VerificationForm from '../components/VerificationForm.vue'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    mixins: [inboxMixin, messageSendMixin],
    components: {
        InboxToolbar,
        PersonProfile,
        MessageTextForm,
        MessageToForm,
        SmsMessagesPanel,
        TriPanel,
        TypingIndicator,
        UserLogo,
        TabPanel,
        VerificationForm
    },
    data() {
        return {
            //  The IListPlaceholder for the channels list
            channelsListPlaceholder: {
                img: 'noConversations',
                imgStyles: { height: '100%' }
            },
            //  If we are commenting on a specific image, this contains the id
            commentMedia: null,
            //  Determines if we are in comment mode or not
            commentMode: false,
            //  If we are commenting on a specific text, this contains the text we are responding to
            commentObject: null,
            //  Our loader we display at the top of our ilist
            loader: false,
            //  Indicates if the component has been mounted (we use this to make sure $refs exist)
            mounted: false,
            //  Displays the full empty state page if true and another condition is true
            showFullEmptyState: true,
            stepIndex: 0,
            //  The toolbar displayed in the tri-panel
            toolbar: {
                title: 'Teammates',
                help: {
                    title: 'Manage your Team',
                    body: "Here is where you can add new teammates, manage your teammate's accounts or send them direct text messages to the mobile phone on file for their account.",
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/4543274-inbox-overview`
                    }
                },
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/home',
                        tooltip: 'Back',
                        permission: 0
                    }
                ]
            }
        }
    },
    beforeDestroy() {
        //  When leaving the inbox, unset everything (the channel watcher will unset the rest)
        this.unsetUser()
    },
    async mounted() {
        //  Check if a user is set in the url params
        const id = this.$route.query.user

        // If id equals myUserProfile
        if (id && id == 'myUserProfile') {
            //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
            const query = Object.assign({}, this.$route.query)

            //  Update the user query param
            query.user = this.user.id

            //  Update the current url
            this.$router.push({ query })
        }

        //  If a user id exists AND it is NOT 'myUserProfile', load it
        else if (id) await this.$store.dispatch('teammatesSelectedUserGet', id)

        //  Check if invite param is set
        const create = this.$route.query.create

        //  If invite is set, open invite dialog
        if (create) this.popNewUser()

        //  Check if verifyEmail query exists
        const verifyEmail = this.$route.query.verifyEmail

        //  If it exists, verifyEmailSend
        if (verifyEmail) this.verifyEmailSend()

        //  Check if verifyPhone query exists
        const verifyPhone = this.$route.query.verifyPhone

        //  If it exists, verifyMobilePhoneSend
        if (verifyPhone) this.verifyMobilePhoneSend()

        //  If either of these queries exist
        if (verifyEmail || verifyPhone) {
            //  Make sure that the team is shown regardelss of team size
            this.showFullEmptyState = false

            //  Update the URL to not include it in the query params
            this.$router.push(`?user=${this.$route.query.user}`)
        }

        //  Check if we have the edit query param
        const edit = this.$route.query.edit

        //  If this is set AND we have a user then lets edit them
        if (edit && this.selectedUser) {
            this.editUser(this.selectedUser)
        }

        //  We use this mounted variable to track when dom elements have been rendered
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            authIsAdmin: 'authIsAdmin',
            authIsSupport: 'authIsSupport',
            invitations: 'teammatesInvitations',
            isApp: 'isApp',
            lastMessagePage: 'teammatesSelectedMessagesLastPage',
            messagesPaginating: 'teammatesSelectedMessagesPaginating',
            messagesParams: 'teammatesSelectedMessagesParams',
            scrollPositionCenter: 'scrollPositionCenter',
            subscription: 'subscription',
            user: 'user',
            users: 'teammatesUsers',
            usersGroup: 'usersGroup'
        }),
        actionButtons(): Button[] {
            if (this.selectedUser) {
                return [
                    {
                        text: 'Reset Password',
                        callback: () => this.popResetPassword(),
                        hidden:
                            !this.$store.getters.userOutranksUser(this.selectedUser) ||
                            !this.user.id === this.selectedUser.id
                    },
                    {
                        text: 'Remove Teammate',
                        callback: () => this.popRemoveTeammate(),
                        icon: 'bi-trash-fill',
                        hidden:
                            !this.$store.getters.userOutranksUser(this.selectedUser) ||
                            this.user.id === this.selectedUser.id
                    }
                ]
            }

            return [
                {
                    text: 'Resend Invitation',
                    callback: () => this.invitationResend(this.selectedInvitation)
                },
                {
                    text: 'Cancel Invitation',
                    callback: () => this.invitationDelete(this.selectedInvitation),
                    icon: 'bi-trash-fill'
                }
            ]
        },
        //  Determine if the selected message tread has more pages
        hasMore() {
            return (
                this.messagesParams.page < this.lastMessagePage && this.messagesPaginating
            )
        },
        invitationCount(): number {
            //  If no invitations, return 0
            if (!this.invitations) return 0

            //  Else count the total that aren't snapdesk/messagedesk/support
            return this.invitations.filter(
                (x: Invitation) =>
                    x.role_id !== 5 &&
                    !x.email.includes('@snapdesk.app') &&
                    !x.email.includes('@messagedesk.com')
            ).length
        },
        //  Items for toolbar dropdown
        items() {
            return [
                {
                    title: 'Invite New Teammate',
                    callback: () => this.popNewUser()
                },
                {
                    title: 'Text Team',
                    callback: () =>
                        this.userCount === 1
                            ? this.popNoTeammates()
                            : this.startTeamBroadcast()
                },
                {
                    title: 'Manage Team Billing',
                    callback: () =>
                        this.userCount === 1
                            ? this.popNoTeammates()
                            : this.$router.push('/billing/manage')
                }
            ]
        },
        //  Number of teammates text
        numOfTeammates(): string {
            return `${this.userCount} / ${this.userLimit} Teammates Added`
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        //  Our currently selected invitation if it exists
        selectedInvitation: {
            get(): Invitation {
                return this.$store.getters.teammatesSelectedInvitation
            },
            set(val: Invitation): void {
                this.$store.commit('teammatesSelectedInvitationSet', val)
            }
        },
        //  The currently selected channel
        selectedChannel: {
            get() {
                return this.$store.getters.teammatesSelectedChannel
            },
            set(channel: Channel) {
                this.$store.commit('teammatesSelectedChannelSet', channel)
            }
        },
        //  The messages of the currently selected channel
        selectedMessages: {
            get() {
                return this.$store.getters.teammatesSelectedMessages
            },
            set(messages: Message[]) {
                this.$store.commit('teammatesSelectedMessagesSet', messages)
            }
        },
        //  The contact bound to the currently selected channel
        selectedPerson: {
            get() {
                return this.$store.getters.teammatesSelectedPerson
            },
            set(person: Person) {
                this.$store.commit('teammatesSelectedPersonSet', person)
            }
        },
        //  The currently selected user
        selectedUser: {
            get(): User {
                return this.$store.getters.teammatesSelectedUser
            },
            set(user: User): void {
                this.$store.commit('teammatesSelectedUserSet', user)
            }
        },
        // We show the empty page state if we have no invitations and only the admin user
        singleUser(): boolean {
            return this.userCount === 1 && this.invitationCount === 0
        },
        tabItems() {
            return [
                {
                    text: 'Profile',
                    icon: 'mdi-account'
                },
                {
                    text: 'Messages',
                    icon: 'bi-chat-square-dots-fill'
                }
            ]
        },
        //  The IList that is hosting the currently loaded users
        teammatesIList() {
            return this.$store.getters.iList('teammatesChannelsList')
        },
        userCount(): number {
            return this.$store.getters.userCount
        },
        userLimit(): number {
            //  Grab our total number of users from our stripe plan
            return this.$store.getters.getLimit('user')
        },
        userPrice(): string {
            //  Get the current product tier
            const tier = this.$store.getters.productTier

            //  If the tier is Team then return 15
            if (tier === 'Team') return '$15/mo'

            //  Else, return 10
            return '$10/mo'
        }
    },
    methods: {
        editUser(user: User): void {
            //  Check if the authenticated user outranks the user being handled
            const iOutrankUser = this.$store.getters.userOutranksUser(user)

            //  If I don't outrank this user, pop access denied
            if (!iOutrankUser) return this.popAccessDenied()

            //  Pop the app-form dialog
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: this.userIsSelf(user) ? 'Edit Profile' : 'Edit Teammate',
                icon: 'mdi-account',
                component: 'user-form',
                closeOnSubmit: true,
                props: {
                    selectedUser: user
                }
            })
        },
        handleEditProfile(): void {
            //  Hide full page empty state
            this.showFullEmptyState = false

            //  Pop edit form for currently authenticated user
            this.editUser(this.user)
        },
        handleInvite(): void {
            //  Hide full page empty state
            this.showFullEmptyState = false

            //  Pop new user form
            this.popNewUser()
        },
        invitationActions(invite: Invitation): IListAction {
            //  Create our menu buttons
            const menu = this.invitationActionsMenu(invite)

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu,
                icon: 'bi-pencil-fill'
            }

            //  Return our newly created action
            return action
        },
        invitationActionsMenu(invite: Invitation, actions: boolean = true): Button[] {
            //Create our menu of buttons
            const menu = [
                {
                    icon: 'mdi-autorenew',
                    text: actions ? 'Resend Invitation' : null,
                    tooltip: 'Resend Invitation',
                    color: 'primary',
                    callback: () => this.invitationResend(invite)
                },
                {
                    icon: 'bi-trash-fill',
                    text: actions ? 'Cancel Teammate Invitation' : null,
                    tooltip: 'Cancel Teammate Invitation',
                    color: 'red',
                    callback: () => this.invitationDelete(invite)
                }
            ]

            //Return our menu
            return menu
        },
        async invitationDelete(invitation: Invitation): Promise<void> {
            //  Send the request to the API
            const response = await this.$store.dispatch('invitationCancel', invitation.id)

            //  If the request failed, do nothing
            if (!response) return

            //  Go back to first half of tabpanel
            if (this.$refs.teammatesPanel) this.$refs.teammatesPanel.step = 1

            //  Notify the user of success
            this.$store.commit('appNotificationBarSet', {
                message: `Invitation to ${invitation.email} successfully cancelled.`
            })

            //  Notify via popup as well
            this.invitationDeleteMessage(invitation.email)
        },
        invitationDeleteMessage(email: string): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Teammate Removed',
                text: `The invitation to ${email} has been removed successfully.\n\nIf the user tries to access the previously sent invitation they will be denied access to your account.\n\nIf you would like to undo this change, simply send them a new invite to your MessageDesk account`,
                icon: 'bi-check-circle-fill',
                color: 'primary',
                closeable: true
            })
        },
        async invitationResend(invitation: Invitation): Promise<void> {
            // Send the request to the API
            const response = this.$store.dispatch('invitationResend', invitation)

            //  If the request failed, do nothing
            if (!response) return

            // Notify user of success
            this.$store.commit('appNotificationBarSet', {
                message: `The invitation was re-sent to ${invitation.email}.`,
                type: 'success',
                closeable: true
            })
        },
        invitationColumns(invite: Invitation) {
            //  Create column one of tile
            const one: IListTileColumn = {
                line1: invite.email,
                line2: 'Pending'
            }
            //  Create column two of tile
            const two: IListTileColumn = {
                line2: `Invite valid until ${invite.expires}`
            }

            //  Add colums to an array
            const columns: IListTileColumn[] = [one, two]

            //  Return columns
            return columns
        },
        invitationIcon(): IListIcon {
            //  Our icon is always the same
            const icon = 'mdi-clock'

            //  Create our IListIcon
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: '#E7A730',
                size: this.$vuetify.breakpoint.smAndDown ? 30 : 36
            }

            //  Return our list icon
            return listIcon
        },
        invitationRole(role_id: number): string {
            const role = {
                1: 'Operator',
                2: 'Manager',
                3: 'Admin'
            }[role_id]

            return role
        },
        invitationsTile(): IListTile {
            return {
                actionContent: (invite: Invitation): IListAction =>
                    this.invitationActions(invite),
                columns: (invite: Invitation): IListTileColumn =>
                    this.invitationColumns(invite),
                leftIcon: (): IListIcon => this.invitationIcon(),
                selectedColor: '#FFDEA1',
                sideBorderColor: '#E7A730',
                sideBorderAlwaysPresent: true,
                callback: (invite: Invitation): void => this.onInvitationSelected(invite)
            }
        },
        onInvitationSelected(invite: Invitation): void {
            //  Unset our user
            this.unsetUser()

            //  Set the step to 2 (for mobile layout only)
            this.$refs.teammatesPanel.step = 2

            //  Check if the invite is different form the currently selected invite
            const isNew =
                !this.selectedInvitation || this.selectedInvitation.id != invite.id

            //  If it is not a new invitation then do nothing
            if (!isNew) return

            //  Else, grab our new invitation
            this.$store.dispatch('teammatesSelectedInvitationGet', invite.id)
        },
        async onPasswordReset(user: User): Promise<void> {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'password-reset-by-email',
                title: 'Reset Password',
                icon: 'mdi-account',
                props: {
                    email: user.email
                },
                color: 'primary',
                closeable: true,
                closeOnSubmit: true,
                callback: async (): Promise<void> => {
                    //  Request a password reset email be sent
                    const response = await this.$store.dispatch(
                        'usersPasswordResetSend',
                        user.id
                    )

                    //  If no response was returned, do nothing
                    if (!response) return

                    //  Else, pop notification
                    this.$store.dispatch('dialogOpen', {
                        type: 'MESSAGE',
                        title: 'Password Reset Sent',
                        text: `A password reset has been sent to ${user.email}. It may take a few minutes for the email to arrive.`,
                        icon: 'mdi-check-circle',
                        color: 'primary'
                    })
                }
            })
        },
        onUserSelected(user: User): void {
            //  Regardless of what happens, unset our invitation
            this.selectedInvitation = null

            //  Check if the user is differnet from the currently selected user
            const isNew = !this.selectedUser || user.id != this.selectedUser.id

            //  Navigate to step 2 of the mobile interface
            this.$refs.teammatesPanel.step = 2

            //  If the user is NOT different from the current user, do nothing else
            if (!isNew) return

            //  Set the selected user
            this.selectedUser = user

            //  clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
            const query = Object.assign({}, this.$route.query)

            //  Update the user query param (there is watcher on this value that handles fetching the messages & person)
            query.user = user.id

            //  Update the current url
            this.$router.push({ query })

            //  Else, just navigate to step 2 of the mobile interface
            this.$refs.teammatesPanel.step = 2
        },
        //  Paginate selected messages. Handles paginate scroll event (ie, paginates page > 1)
        async paginateMessageList(): Promise<void> {
            //  Grab our current channel
            const channel = this.selectedChannel

            //  If no channel, return
            if (!channel) return

            //  Else, grab our channel id
            const id = channel.id

            //  Get current pagination params
            const params = this.messagesParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine if we should paginate
            const shouldPaginate = nextPage <= this.lastMessagePage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update our pagination params
            params.page = nextPage
            this.$store.commit('teammatesSelectedMessagesParamsSet', params)

            //  Paginate the next page
            await this.$store.dispatch('teammatesSelectedMessagesPaginate', id)

            //  Scroll to the last position
            this.$refs['teammatesPanel'].scrollTo(this.scrollPositionCenter)
        },
        passwordResetManually(user: User): void {
            //  Open up a form to change password
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'password-reset-form',
                title: 'Reset Password',
                icon: 'mdi-lock-reset',
                props: {
                    userId: user.id
                },
                closeable: true,
                closeOnSubmit: true
            })
        },
        popAccessDenied(): void {
            //  Pop Dialog stating message
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Access Denied',
                text: `You don’t have permission to edit other teammates profiles.\n\nAsk your account admin to update your permissions if you’d like to proceed.`,
                icon: 'bi-exclamation-circle-fill',
                closeable: true,
                linkText: 'Close'
            })
        },
        popNewUser(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Invite a Teammate',
                icon: 'mdi-account',
                color: 'primary',
                component: 'invitations-form',
                closeable: true,
                closeOnSubmit: true,
                class: 'pa-2',
                props: {
                    dialog: true
                }
            })
        },
        popInvitationEdit(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Invite Pending',
                text: 'Teammates cannot be edited until they have accepted your invitation. To resend the invitation or update the email address of the teammate simply click “Resend Invitation”.\n\nIf you would like to cancel the pending invitation simply click “Cancel Invitation”',
                icon: 'bi-question-circle-fill',
                color: 'primary',
                closeable: true
            })
        },
        popNoTeammates(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'No Teammates Yet',
                text: `You have not added teammates to your MessageDesk account yet. Add teammates to your account to take advantage of team features such as conversation assignment and comments\n\nIf you would like to cancel the pending invitation simply click “Cancel Invitation”`,
                icon: 'bi-question-circle-fill',
                color: 'primary',
                closeable: true,
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
            })
        },
        popResetPassword(): void {
            //  Check if the user being handled is the current auth user
            const isSelf = this.selectedUser.id === this.$store.getters.user.id

            //  Check if the authenticated user outranks the user being handled
            const iOutrankUser = this.$store.getters.userOutranksUser(this.selectedUser)

            //  If the user beig edited is the one being authenticatied, pop reset password form
            if (isSelf) return this.passwordResetManually(this.selectedUser)

            //  If not self and outrank the user being edited, pop form to send the user an email
            if (!isSelf && iOutrankUser) this.onPasswordReset(this.selectedUser)
        },
        popRemoveTeammate(user: User = null): void {
            //Pop an app form with the VerificationForm component to verify phone
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Remove Teammate',
                color: '#F44336',
                component: 'remove-teammate',
                props: {
                    selectedUser: user ? user : this.selectedUser
                },
                closeable: true,
                closeOnSubmit: true,
                icon: 'bi-trash-fill',
                width: this.$vuetify.breakpoint.mdAndUp ? '650px' : '400px'
            })

            //  Go back to first half of tabpanel
            if (this.$refs.teammatesPanel) this.$refs.teammatesPanel.step = 1
        },
        popRoleHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Teammate Permissions Explained',
                text: `MessageDesk supports 3 levels of permission: Admin, Manager, Operator.\n\n<b>Admin</b>: the creator of your MessageDesk account. This person has access to everything and is the only person who can update the account’s subscription. Each account can only have 1 Admin. To change this admin, please email support@messagedesk.com.\n\n<b>Manager</b>: Has the same level of feature access as the Admin but is not the point of contact for the account. They are prevented from updating the account’s phone number or payment details. This is great for teammates who need all-access to the platform.\n\n<b>Operator</b>: Has limited access to MessageDesk features. They are unable to delete existing contacts, create or edit SMS campaigns, and unable to upload contact data in bulk via CSV uploads. This is great for teammates who may need to send a Broadcast, manage the inbox or need to export information from MessageDesk.`,
                icon: 'bi-question-circle-fill',
                color: '#717171',
                closeable: true,
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
            })
        },
        popTeamInboxVideo(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Watch: Team-Inbox Overview',
                color: 'primary',
                embedded: `<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/09866ca1154a4fb28324e741816e0e3c" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`,
                icon: 'bi-play-circle-fill',
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '200px'
            })
        },
        popMobilePhoneVerify(): void {
            //Pop an app form with the VerificationForm component to verify phone
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                color: 'primary',
                component: 'verification-form',
                props: {
                    dialog: true,
                    titleText: 'Check Your    ',
                    imgTitle: this.$images.phoneWithArrow,
                    methodOfVerification: this.$options.filters.userPhone(this.user)
                },
                closeable: true,
                closeOnSubmit: false,
                class: 'pa-2',
                callback: (type: any): void => {
                    // Based on the type passed in, route to a different function
                    const cb = {
                        verify: () => this.verifyMobilePhone(type.code),
                        resend: () => this.verifyMobilePhoneResend()
                    }
                    // Route
                    cb[type.type]()
                }
            })
        },
        popEmailVerify(): void {
            //Pop an app form with the VerificationForm component to verify email
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                color: 'primary',
                component: 'verification-form',
                props: {
                    dialog: true,
                    titleText: 'Check Your Email',
                    methodOfVerification: this.user.email
                },
                closeable: true,
                closeOnSubmit: false,
                class: 'pa-2',
                callback: (type: any): void => {
                    // Based on the type passed in, route to a different function
                    const cb = {
                        verify: () => this.verifyEmail(type.code),
                        resend: () => this.verifyEmailResend()
                    }
                    // Route
                    cb[type.type]()
                }
            })
        },
        async sendMessage(message: Message): Promise<void> {
            //  Tell our message form to start loading (ux on send button)
            this.$refs.messageForm.sending = true

            //  Else, we don't want the preview so just send
            const response = await this.$store.dispatch('messagesPost', message)

            //  Our message is sent, tell our form to stop loading
            this.$refs.messageForm.sending = false

            //  If the message send failed, do nothing
            if (!response) return

            //  Reset the message text form
            this.$refs.messageForm.reset()
        },
        //  Route to broadcasts with team group selected
        startTeamBroadcast(): void {
            //  Report to Analytics
            Analytics.track('TextTeamClicked')

            //  Get group of all messagedesk users and set id in route
            return this.$router.push(`/broadcasts/create?group=${this.usersGroup.id}`)
        },
        //  Tab Panel Index setter
        tabChange(stepIndex: number): void {
            this.stepIndex = stepIndex
        },
        //  Reset the teammates's selected items
        unsetUser(hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) return

            //  Unset our channel
            this.selectedChannel = null

            //  Unset our messages
            this.selectedMessages = []

            //  Unset our person
            this.selectedPerson = null

            //  Unset our user
            this.selectedUser = null

            //  Change tab panel index to 0 (Back to profile tab)
            if (this.$refs.tabPanel) this.$refs.tabPanel.activeIndex = 0

            //  Making sure to update out local variable in charge of tab step index
            this.stepIndex = 0

            //  Remove our comment response
            this.commentResponse = null

            //  Grab our current path
            const path = this.$route.path

            //  If the path is NOT teammates we are done
            if (!path.includes('teammates')) return

            //  Reset the message text form
            if (!this.selectedInvitation && this.stepIndex == 1)
                this.$refs.messageForm.reset()

            //  If our query does not have a user, we are done
            if (!this.$route.query.user) return

            //  Remove the user query params from the route
            this.$router.replace({ user: {} })
        },
        userActions(user: User): IListAction {
            //  Create our menu of buttons
            const menu = this.userActionsMenu(user)

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu,
                icon: 'bi-pencil-fill'
            }

            //  Return our action menu
            return action
        },
        userActionsMenu(user: User, actions: boolean = true): Button[] {
            //  Check if the authenticated user outranks the user being handled
            const iOutrankUser = this.$store.getters.userOutranksUser(user)

            //  Check if the user being handled is the tenant's admin user
            const isAdmin = user.id === this.$store.getters.tenant.admin_user_id

            //  Check if the user being handled is the current auth user
            const isSelf = user.id === this.$store.getters.user.id

            //  Create our menu of buttons
            const menu: Button[] = [
                {
                    icon: 'mdi-pencil-outline',
                    text: actions
                        ? this.userIsSelf(user)
                            ? 'Edit Profile'
                            : 'Edit Teammate'
                        : null,
                    tooltip: 'Edit Teammate',
                    color: 'primary',
                    disabledPopup: null,
                    hidden: !iOutrankUser,
                    callback: () => this.editUser(user)
                },
                {
                    icon: 'mdi-lock-reset',
                    text: actions ? 'Reset Password' : null,
                    tooltip: 'Send Password Reset Email',
                    color: 'primary',
                    disabledPopup: this.operator,
                    hidden: isSelf || !iOutrankUser,
                    callback: () => this.onPasswordReset(user)
                },
                {
                    icon: 'mdi-lock-reset',
                    text: actions ? 'Reset Password' : null,
                    tooltip: 'Reset Password',
                    color: 'primary',
                    disabledPopup: null,
                    hidden: !isSelf,
                    callback: () => this.passwordResetManually(user)
                },
                {
                    icon: 'bi-trash-fill',
                    text: actions ? 'Remove Teammate' : null,
                    tooltip: 'Remove Teammate',
                    color: 'primary',
                    disabledPopup: this.operator,
                    hidden: isAdmin || isSelf || !iOutrankUser,
                    callback: () => this.popRemoveTeammate(user)
                }
            ]

            //  Return our menu
            return menu
        },
        usersTileColumns(user: User) {
            //  Create column one of tile
            const one: IListTileColumn = {
                line1: this.$options.filters.userFullNameOrEmail(user),
                line2: this.$options.filters.userPhone(user),
                line3: this.userRole(user)
            }
            //  Create column two of tile
            const two: IListTileColumn = {
                line2: user.email
            }

            //  Add colums to an array
            const columns: IListTileColumn[] = [one, two]

            //  Return columns
            return columns
        },
        userIcon(user: User): IListIcon {
            //  Grab an avatar from the user if it exists
            const avatar = user.logo_route?.remote_link

            //  Our badge for our users
            const badge: IListBadge = {
                color: 'primary',
                icon: 'mdi-check'
            }

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: avatar ? IListIconType.avatar : IListIconType.initials,
                content: avatar ? avatar : null,
                color: 'primary',
                initials: avatar ? null : this.$options.filters.userInitials(user),
                size: this.$vuetify.breakpoint.smAndDown ? 30 : 36
            }

            //  Return our icon
            return listIcon
        },
        userIsSelf(user: User): boolean {
            return this.$store.getters.userIsSelf(user)
        },
        userRole(user: User): string {
            //  Grab the role for this user
            const role = this.$store.getters.userRole(user)

            //  If there isn't a role, return "Teammate Removed"
            if (!role) return 'Teammate Removed'

            //  Else, return the role name
            return role.name
        },
        //  The users tile bound to the users list
        usersTile(): IListTile {
            return {
                // actionHeader: (channel: Channel) => f.channelStatus(channel),
                // actionContent: (channel: Channel) => this.channelAction(channel),
                // actionFooter: (channel: Channel) => f.channelWaiting(channel),
                actionContent: (user: User) => this.userActions(user),
                columns: (user: User) => this.usersTileColumns(user),
                leftIcon: (user: User) => this.userIcon(user),
                callback: (user: User) => this.onUserSelected(user)
            }
        },
        async verifyEmail(code: string): Promise<void> {
            // Create our payload
            const payload = {
                code: code,
                user_id: this.user.id
            }
            //  Send the verification code to the api
            const verified = await this.$store.dispatch('authVerifyEmail', payload)

            //  Close the app-form dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  If the verification failed, do nothing
            if (!verified) return

            // If phone is unverified, initiate phone verification
            if (!this.user.mobilephone_verified) this.verifyMobilePhoneSend()
        },
        async verifyEmailSend(): Promise<void> {
            //  Send a verification code to the user's email
            const response = await this.$store.dispatch('authVerifyEmailSend')

            //  If the response failed, do nothing
            if (!response) return

            //  Pop email verification form
            this.popEmailVerify()
        },
        async verifyEmailResend(): Promise<void> {
            //  Send a verification code to the user's email
            const response = await this.$store.dispatch('authVerifyEmailSend')

            //  If the response failed, do nothing
            if (!response) return
        },
        async verifyMobilePhone(code: string): Promise<void> {
            // Create our payload
            const payload = {
                code: code
            }

            //  Send the verification code to the api
            const verified = await this.$store.dispatch('authVerifyPhone', payload)

            //  If the verification failed, let them know
            if (!verified)
                return this.$store.commit('appNotificationBarSet', {
                    message: 'Incorrect Code',
                    type: 'error',
                    closeable: true
                })

            //  Close the app-form dialog
            this.$store.dispatch('dialogClose', 'APP')

            // If email is unverified, intitate email verification
            if (!this.user.email_verified) this.verifyEmailSend()
        },
        async verifyMobilePhoneSend(): Promise<void> {
            //  Send a verification code to the user's pjone
            const response = await this.$store.dispatch('authVerifyPhoneSend')

            //  If the response failed, do nothing
            if (!response) return

            //  Pop email verification form
            this.popMobilePhoneVerify()
        },
        async verifyMobilePhoneResend(): Promise<void> {
            //  Send a verification code to the user's email
            const response = await this.$store.dispatch('authVerifyPhoneSend')

            //  If the response failed, do nothing
            if (!response) return
        }
    },
    watch: {
        // Watch for changes to 'user' query parameter
        $route(to, from) {
            //  If the 'user' query param does NOT exist, unset our selected data
            if (!to.query.user) return this.unsetUser()

            //  Check if we have a new message query
            const newMsg = to.query.newMessage

            //  If it exists, then just move to step 2 and that's it
            if (newMsg) return (this.$refs.teammatesPanel.step = 2)

            //  Else, get the user id from the query param
            const id = to.query.user

            //  Check if 'user' param is different from the currently loaded user
            const needsLoad = !this.selectedUser || id != this.selectedUser.id

            //  If a user does NOT need to be loaded, do nothing
            if (!needsLoad) return

            //  We need to load the user so move
            this.$refs.teammatesPanel.step = 2

            if (id == 'myUserProfile') {
                //  Fetch the auth user
                this.$store.dispatch('teammatesSelectedUserGet', this.user.id)

                //  Check if verifyEmail query exists
                const verifyEmail = this.$route.query.verifyEmail

                //  If it exists, verify user's email
                if (verifyEmail) this.verifyEmailSend()

                //  Check if verifyPhone query exists
                const verifyPhone = this.$route.query.verifyPhone

                //  If it exists, verify user's phone
                if (verifyPhone) this.verifyMobilePhoneSend()

                //  If either params exists
                if (verifyEmail || verifyPhone) {
                    //  Make sure that the team is shown regardelss of team size
                    this.showFullEmptyState = false

                    //  Update the URL to only include user's id
                    this.$router.push(`?user=${this.user.id}`)
                }

                return
            }

            //  Else, fetch the new user
            this.$store.dispatch('teammatesSelectedUserGet', id)
        },
        selectedChannel(channel: Channel | null, prev: Channel | null) {
            //  If the channel was set to null, we need to remove the selected messages, person, and drafts
            if (!channel) return this.unsetUser()

            //  IF the channel didn't change, do nothing
            if (channel.id === prev?.id) return

            //  Else, the channel is new so we should reset the messages
            this.selectedMessages = []

            //  Update the read status on this channel
            // this.$store.dispatch('channelsPut', { ...channel, unread_messages: 0 })

            //  The selected channel has changed, we need to update the SmsPanel
            this.$store.dispatch('teammatesSelectedMessagesPaginate', channel.id)
        },
        selectedPerson(person: Person, prev: Person): void {
            //  If the user was set to null, we need to remove everything
            if (!person) return this.unsetUser()

            //  If the user didn't change, do nothing
            if (person.id == prev?.id) return

            //  Else, the users is new so we should get our channel
            this.$store.dispatch('teammatesSelectedChannelGet', person.primary_channel_id)
        },
        selectedUser(user: User, prev: User): void {
            //  If the user was set to null, we need to remove everything
            if (!user) return this.unsetUser()

            //  If the user didn't change, do nothing
            if (user.id == prev?.id) return

            //  Else, the users is new so we should get our person
            this.$store.dispatch('teammatesSelectedPersonGet', user.id)
        },
        scrollPositionCenter(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at top, paginate next page
            if (!this.messagesPaginating && position.top) this.paginateMessageList()
        }
    }
})
